import { Button, Popup, ScrollView } from "devextreme-react";
import VendorGrid from "./VendorGrid";
import { Component } from "devextreme-react/core/component";
import PropTypes from "prop-types";

export const VendorModal = (props) => {
  Component.propTypes = {
    onClose: PropTypes.func,
    name: PropTypes.string,
    internalId: PropTypes.string,
  };

  const { onClose, name, internalId } = props;

  const renderTitle = () => {
    return (
      <>
        <h3>{name} - Vendor Inventory </h3>
      </>
    );
  };
  const renderCloseButton = () => {
    return (
      <div style={{ paddingTop: "10px", right: "1vw", top: "4vh" }}>
        <Button onClick={() => onClose("vendor", false)}>X</Button>
      </div>
    );
  };
  const displayTitle = () => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {renderTitle()}
          {renderCloseButton()}
        </div>
      </>
    );
  };

  return (
    <>
      <Popup
        id="popup"
        visible={true}
        onHiding={onClose}
        showTitle={true}
        titleRender={displayTitle}
        width="55vw"
        height="25vw"
        resizeEnabled={true}
      >
        <div>
          <ScrollView height="100%" width="100%">
            <VendorGrid internalId={internalId} />
          </ScrollView>
        </div>
      </Popup>
    </>
  );
};
